module.exports = "<app-layout *ngIf=\"!hideLayout\"></app-layout>\n<app-login *ngIf=\"url === '/login'\"></app-login>\n\n\n"